import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
} from "@chakra-ui/react";

import { IFormField } from "./fieldTypes";

/**
 * JsonForm Text Field component.
 * @param props see {@link IFormField}
 */
function TextField({
  field,
  isRequired,
  register,
  disabled = false,
  errorMessage = "",
}: IFormField) {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errorMessage}>
      <FormLabel>{field.label}</FormLabel>
      <Input
        {...register(field.fieldName, field.config)}
        type={field.inputType}
        placeholder={field.placeholder}
        autoComplete={field.autocomplete}
        disabled={disabled}
      />
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
      {!errorMessage && field.helperText && (
        <FormHelperText>{field.helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

export { TextField };
